import { useTranslation } from "react-i18next";

import { sortRoleByPriority } from "@/entities/user-role";
import { ModelList } from "@/modules/model-list";

const UserRolesList = ({ roles }) => {
  const { t } = useTranslation();

  // sort roles by priority and translate them
  const translatedSortedRoles = (roles ?? [])
    .map((role) => {
      const key = role.subject_id
        ? role.name.substr(0, role.name.lastIndexOf("."))
        : role.name;
      return {
        name: t(`role:${key.replace(".", "")}`),
        key,
      };
    })
    .sort(sortRoleByPriority)
    .filter((role, pos, allRoles) => {
      return !pos || role.key !== allRoles[pos - 1].key;
    });

  return <ModelList model="role" items={translatedSortedRoles} />;
};

export default UserRolesList;
